import lmsLoginAuthSlice from 'src/models/auth/lmsLogin/slice';
import authSlice from 'src/models/auth/slice';
import DetailsModelSlice from 'src/models/details/slice';
import filtersSlice from 'src/models/filters/slice';
import lmsConfigSlice from 'src/models/lmsConfig/slice';
import moduleButtonsSlice from 'src/models/moduleButtons/slice';
import AuthModule from 'src/modules/auth/module';
import AuthLegacyModule from 'src/modules/authLegacy/module';
import authLegacySlice from 'src/modules/authLegacy/slice';
import BreadcrumbModule from 'src/modules/breadcrumb/module';
import CopilotModule from 'src/modules/copilot/module';
import copilotSlice from 'src/modules/copilot/slice';
import Details360Module from 'src/modules/details360/module';
import Details360Slice from 'src/modules/details360/slice';
import FormAuthModule from 'src/modules/formAuth/module';
import FormAuthSlice from 'src/modules/formAuth/slice';
import GenericListModule from 'src/modules/genericList/module';
import GenericListSlice from 'src/modules/genericList/slice';
import HeaderModule from 'src/modules/header/module';
import NavbarSlice from 'src/modules/header/vymoWeb/slice';
import HomeDashboardModule from 'src/modules/homeDashboard/module';
import homeDashboardSlice from 'src/modules/homeDashboard/slice';
import LegacyWebInterfaceModule from 'src/modules/legacyWebInterface/module';
import NotesModule from 'src/modules/notes/module';
import NotesSlice from 'src/modules/notes/slice';
import PerformanceModule from 'src/modules/performance/module';
import PerformanceDashboardSlice from 'src/modules/performance/slice';
import RevyreModule from 'src/modules/revyre/module';
import RevyreSlice from 'src/modules/revyre/slice';
import SampleDialog from 'src/modules/sampleDialogModal/module';
import SampleFormModule from 'src/modules/sampleForm/module';
import SidebarModule from 'src/modules/sidebar/module';
import SPGWidget from 'src/modules/spg/module';
import SPGWidgetSlice from 'src/modules/spg/slice';
import ProgressiveStepper from 'src/modules/stepper/module';
import progressiveStepperSlice from 'src/modules/stepper/slice';
import SuperSetDashboardModule from 'src/modules/superset/module';
import User360Module from 'src/modules/user360/module';
import User360Slice from 'src/modules/user360/slice';
import UserProfileModule from 'src/modules/userProfile/module';
import UserProfileSlice from 'src/modules/userProfile/slice';
import VymoBannerModule from 'src/modules/vymoBanner/module';
import WorkflowFormModule from 'src/modules/workflowForm/module';
import WorkflowFormSlice from 'src/modules/workflowForm/slice';

export const moduleList = {
  ...HomeDashboardModule,
  ...SampleFormModule,
  ...SampleDialog,
  ...CopilotModule,
  ...ProgressiveStepper,
  ...AuthLegacyModule,
  ...SuperSetDashboardModule,
  ...HeaderModule,
  ...SidebarModule,
  ...AuthModule,
  ...UserProfileModule,
  ...User360Module,
  ...WorkflowFormModule,
  ...SPGWidget,
  ...RevyreModule,
  ...BreadcrumbModule,
  ...LegacyWebInterfaceModule,
  ...VymoBannerModule,
  ...GenericListModule,
  ...FormAuthModule,
  ...PerformanceModule,
  ...Details360Module,
  ...NotesModule,
};

export const reducerList = {
  ...lmsLoginAuthSlice,
  ...copilotSlice,
  ...progressiveStepperSlice,
  ...authLegacySlice,
  ...authSlice,
  ...UserProfileSlice,
  ...User360Slice,
  ...WorkflowFormSlice,
  ...lmsConfigSlice,
  ...SPGWidgetSlice,
  ...RevyreSlice,
  ...homeDashboardSlice,
  ...NavbarSlice,
  ...GenericListSlice,
  ...FormAuthSlice,
  ...filtersSlice,
  ...moduleButtonsSlice,
  ...PerformanceDashboardSlice,
  ...Details360Slice,
  ...DetailsModelSlice,
  ...NotesSlice,
};
